export class LogoutService {
  public async logout(url: string): Promise<void> {
    window.location.href = url;
    return Promise.resolve();
  }
}
